// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2dpvc","header":"PatientQuestionnaire_header__85Srp","info":"PatientQuestionnaire_info__8mWVc"};